import { React } from "react";
import { Link } from "react-router-dom";
import { AppBar, Typography, Button, Toolbar, Avatar } from "@material-ui/core";
import useStyles from "./styles.js";
import gemstone from "../../../images/gemstone.png";
import umd from "../../../images/umd.png";

const Footer = () => {
    const classes = useStyles();

    return (
        <footer className={classes.footer}>
            <div className={classes.images}>
                <a href="http://www.gemstone.umd.edu" target="_blank">
                    <img
                        src={gemstone}
                        alt="Gemstone Honors College"
                        height="120px"
                        className={classes.image}
                    ></img>
                </a>
                <a href="http://www.honors.umd.edu" target="_blank">
                    <img
                        src={umd}
                        alt="University of Maryland"
                        height="120px"
                        className={classes.image}
                    ></img>
                </a>
            </div>
        </footer>
    );
};

export default Footer;
